import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
// import { AccountBookFilled } from "@ant-design/icons";
import Question from "./question";

function FrequentAsked({ mode }) {
  function getWindowDimensions() {
    const { innerHeight: height, innerWidth: width } = window;

    return { height, width };
  }
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title>Frequent Asked Questions | PMT</title>
        </MetaTags>

        <Row className="mb-5">
          {mode === "Rewards" ? (
            ""
          ) : (
            <Col
              span={24}
              className={
                windowDimensions.width > 991 && windowDimensions.width < 1024
                  ? "mt-[41px]"
                  : "lg:mt-[41px] xl:mt-[-30px] mt-[-30px]"
              }
            >
              <div className="questions-image relative">{/* PMTC */}</div>
            </Col>
          )}

          <Col span={24} className="flex justify-start">
            <Question />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default FrequentAsked;
